export enum FilterDateIntervalEnum {
  YEARS = 'YEAR',
  MONTHS = 'MONTH',
  DAYS = 'DAY',
  QUARTERS = 'QUARTER',
  WEEKS = 'WEEK',
  HOURS = 'HOUR',
  MINUTES = 'MINUTE',
  SECONDS = 'SECOND',
}
